module.exports = __webpack_public_path__ + "static/media/videoCopy.d01a9fe3.svg";